import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { WizBasePopUp, WizCommand, WizIcon } from '@wizeoo/akm-component-lib';


@Component({
  // affichage des erreurs de service
  selector: 'cmderror-pop',
  templateUrl: './cmderror.pop.html',
})
export class CmdErrorPop extends WizBasePopUp {
  
  
  public icon : any = WizIcon.TOAST_ERROR; // l'icone erreur
  public title: string = '';
  public message: string = '';
  public stack: string = '';
  declare public datas: WizCommand<any>;

  public show(): void {
    super.show();
    this.title = (this.datas as any).constructor.name;
    try {
      this.message = this.datas.error.message;
      this.stack = (this.datas.error as HttpErrorResponse).error.trace;
    } catch (e: any) {

    }

  }
  
}
